var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class:
        ((_obj = {}),
        (_obj[_vm.$style.section] = true),
        (_obj[_vm.$style.alternateBackground] = _vm.useAlternateBgColor),
        (_obj[_vm.backgroundClass] = !_vm.useAlternateBgColor),
        _obj)
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }